import { useFeatureFlagContext } from './featureFlagContext';

export function useFeatureFlags() {
  return useFeatureFlagContext();
}
